import { call, put, takeLatest } from 'redux-saga/effects'

import {
  addDevice,
  editDevice,
  getAllDevices,
  getDevice,
  deleteDevice,
  clearSelectedDevice
} from './device.reducer'
import Api from '../services/ApiCaller'
import { IDevice } from './device.interface'

import { push } from 'connected-react-router'
import { showMessage } from '../utils'
import {successfulAdd, successfulEdit, sucessfulDelete} from './constants'

export function* addDeviceRequest(api: Function, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      showMessage(successfulAdd)
      yield put(addDevice.success())
      yield put(push('/devices'))
    } else {
      yield put(addDevice.failure(message))
    }
  } catch (e) {
    yield put(addDevice.failure(e.message))
  }
}

export function* getDeviceRequest(api: Function, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      yield put(getDevice.success(res))
    } else {
      yield put(getDevice.failure(message))
    }
  } catch (e) {
    yield put(getDevice.failure(e.message))
  }
}

export function* getAllDevicesRequest(api: Function, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      yield put(getAllDevices.success(res))
    } else {
      yield put(getAllDevices.failure(message))
    }
  } catch (e) {
    yield put(getAllDevices.failure(e.message))
  }
}

function* editDeviceRequest(api: Function, { payload }: any) {
  try {
    // Cahnges this ...
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      showMessage(successfulEdit)
      yield put(editDevice.success(res))
      yield put(push('/devices'))
    } else {
      yield put(editDevice.failure(message))
    }
  } catch (e) {
    yield put(editDevice.failure(e.message))
  }
}

function* deleteDeviceRequest(api: Function, { payload }: any) {
  try {
    // Cahnges this ...
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      showMessage(sucessfulDelete)
      yield put(deleteDevice.success(res))
      yield put(push('/devices'))
    } else {
      yield put(deleteDevice.failure(message))
    }
  } catch (e) {
    yield put(deleteDevice.failure(e.message))
  }
}
interface IidData {
  id: number
}

function * clearDeviceRequest() {
  yield put (clearSelectedDevice.success())

}

export default (api: any) => {
  const addDeviceApi = (data: IDevice[]) => api.post('/devices', data)
  const getDeviceApi = (data: IidData) => api.get(`/devices/${data.id}`, data)
  const editDeviceApi = (data: IidData) => api.put(`/devices/${data.id}`, data)
  const deleteDeviceApi = (data: IidData) => api.delete(`/devices/${data.id}`, data)
  const getAllDevicesApi = (data: any) => api.get('/devices', data)

  return [
    takeLatest(addDevice.TRIGGER, addDeviceRequest, addDeviceApi),
    takeLatest(getDevice.TRIGGER, getDeviceRequest, getDeviceApi),
    takeLatest(editDevice.TRIGGER, editDeviceRequest, editDeviceApi),
    takeLatest(deleteDevice.TRIGGER, deleteDeviceRequest, deleteDeviceApi),
    takeLatest(getAllDevices.TRIGGER, getAllDevicesRequest, getAllDevicesApi),
    takeLatest(clearSelectedDevice.TRIGGER, clearDeviceRequest),
  ]
}
